import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'
import { useNavigate } from 'react-router-dom'

import { wholesaleMarketClient } from '@/api'
import { config } from '@/config'

const BASE_ROUTE = config.links.library.wholesaleMarket
const BASE_QUERY_KEY = wholesaleMarketClient.QUERY_KEY

export const useWholesaleMarketDatasets = () => {
  const { showSuccess } = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const getWholesaleDatasetsQuery = useQuery({
    queryKey: [...BASE_QUERY_KEY, { lockedOnly: false }],
    queryFn: () => wholesaleMarketClient.getAll()
  })

  const addDatasetMutation = useMutation({
    mutationFn: wholesaleMarketClient.addNewDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully added')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const cloneDatasetMutation = useMutation({
    mutationFn: wholesaleMarketClient.cloneDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully cloned')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const removeDatasetMutation = useMutation({
    mutationFn: wholesaleMarketClient.removeDataset,
    onSuccess: async () => {
      showSuccess('Dataset successfully removed')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  return {
    wholesaleMarketDatasets: getWholesaleDatasetsQuery.data || [],
    isFetching: getWholesaleDatasetsQuery.isFetching,
    addDataset: addDatasetMutation.mutate,
    isAddDatasetInProgress: addDatasetMutation.isPending,
    removeDataset: removeDatasetMutation.mutate,
    cloneDataset: cloneDatasetMutation.mutate,
    isCloneDatasetInProgress: cloneDatasetMutation.isPending
  }
}
